import useStyles from './styles'
import {Typography,Grid, Container} from '@material-ui/core';
import React from 'react';

const Home = (props)=>{
    const classes = useStyles();
    const welcome = 'Welcome, I am';
    const name = 'Akash Hegde';
    const about = 'I am 3rd year engineering student who is always looking out for new skills, I am regularly improving my skills in the industry and looking for good opportuinites to work.I have completed many projects in web developement and also in Machine Learning';
    return(
        <main className={classes.main}>
            <Grid className={classes.grid} container spacing={2}>

                <Grid className={`${classes.items} ${classes.imageContainer}`} item xs={12} sm={12} md={6} lg={6} >
                        <img className={classes.image} src='akash.jpg' alt='akash'/>
                </Grid>
                <Grid className={`${classes.items} ${classes.about}`} xs={12} sm={12} md={6} lg={6} item >
                    <Container maxWidth='lg' align='center'>

                        <Typography variant='h4' align='left' gutterBottom>
                            {/* {welcome.map(wel=>(<span key={Math.random()} className={classes.highlight}>{wel}</span>))} */}
                            {welcome}
                        </Typography>


                        <Typography variant='h1' align='left'>
                            {/* {name.map((letter)=>(<span key={Math.random()} className={classes.highlight}>{letter}</span>))} */}
                            {name}
                        </Typography>

                            <Typography className={classes.about1} variant='body1'>
                                {/* {about.map(word=>(<span key={Math.random()} className={classes.highlight}>{word} </span>))} */}
                                {about}
                            </Typography>
                    </Container>
                </Grid>
            </Grid>
        </main>
    )
}
export default Home;